"use client";

import Image from "next/image";
import Link from "next/link";

type LogoProps = {
  isMounted: boolean;
  isScrolled: boolean;
};

const Logo = ({ isMounted, isScrolled }: LogoProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Always force a full page reload when navigating to home to ensure animations trigger
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      window.location.href = "/";
    }, 300);
  };

  return (
    <div>
      <Link
        aria-label="WillPower Store home"
        className="flex items-center justify-center"
        href="/"
        onClick={handleClick}
      >
        <div
          className={`flex items-center space-x-3 transition-transform duration-300 ease-in-out ${
            isMounted && isScrolled
              ? "scale-100"
              : "scale-105 sm:scale-110 lg:scale-110 xl:scale-110"
          }`}
          suppressHydrationWarning
        >
          {/* <div className="heading-display hidden items-center gap-2 font-bold font-heading text-[1.25rem] leading-[1.25rem] sm:flex sm:text-[1.75rem] sm:leading-[1.75rem] lg:text-[3rem] lg:leading-[3rem] xl:text-[3.5rem] xl:leading-[3.5rem]">
            <span className="text-primary">WILLPOWER</span>
            <span className="text-muted-foreground">STORE</span>
          </div> */}
          <Image
            alt="WillPower Store Logo"
            className="h-20 w-auto sm:h-20 md:h-24 lg:h-28 xl:h-32"
            height={128}
            priority
            sizes="(min-width: 1280px) 128px, (min-width: 1024px) 112px, (min-width: 768px) 96px, (min-width: 640px) 80px, 80px"
            src="/images/logo-1.svg"
            width={128}
          />
        </div>
      </Link>
    </div>
  );
};

export default Logo;
